import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { FormGroup, FormControl, Validators } from "@angular/forms";
import { RoutingConstants } from "../../constants/routingConstants";
import { ToastrAlertService } from "src/app/core/services/toastrAlert.service";
import { PrintsRulesService } from "../prints-rules.service";
import { ListValueService } from "src/app/core/services/list-value.service";
import { CommonService } from "src/app/core/services/common.service";

@Component({
  selector: "app-create-edit-prints-rules",
  templateUrl: "./create-edit-prints-rules.component.html",
  styleUrls: ["./create-edit-prints-rules.component.sass"],
})
export class CreateEditPrintsRulesComponent implements OnInit {
  operation: string;
  routing = RoutingConstants.printsRulesRouting;
  printsRules: any;
  listValuesEtiqueta = [];
  listValuesFabricantes = [];
  listValuesFormatosImpresion = [];
  listValuesMarcas = [];

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private toastrAlertService: ToastrAlertService,
    private printsRulesService: PrintsRulesService,
    private listValueService: ListValueService,
    private commonService: CommonService
  ) {}

  ngOnInit(): void {
    this.getlistValuesFabricantes();
    this.getlistValuesEtiqueta();
    this.getlistValuesFormatosImpresion();
    this.initFormGroup();
    this.operation = this.activatedRoute.data["_value"]["operation"];
  }

  initFormGroup() {
    this.printsRules = new FormGroup({
      formatosimpresion: new FormGroup({
        fiDesc: new FormControl(""),
        fiId: new FormControl("", Validators.required),
      }),
      riIndice: new FormControl(""),
      riMarca: new FormControl("", Validators.required),
      riTipoEtiqueta: new FormControl("", [Validators.required]),
      riTipoHomologado: new FormControl("", [
        Validators.maxLength(27),
        Validators.required,
      ]),
      tetiqueta: new FormGroup({
        tpNombre: new FormControl("", [Validators.required]),
        tpTipo: new FormControl(""),
      }),
    });
  }

  setValues(data) {
    let riMarca = this.listValuesMarcas.find(
      (item) => item["maDescr"] === data.riMarca
    );
    let riFabricantes = this.listValuesFabricantes.find(
      (item) =>
        item["TipoPlaca"].toLowerCase() === data.riTipoEtiqueta.toLowerCase()
    );

    this.printsRules.patchValue({
      formatosimpresion: {
        fiDesc: data.formatosimpresion.fiDesc,
        fiId: data.formatosimpresion.fiId,
      },
      riIndice: data.riIndice,
      riMarca: riMarca,
      riTipoEtiqueta: riFabricantes,
      riTipoHomologado: data.riTipoHomologado,
      tetiqueta: {
        tpNombre: data.tetiqueta.tpNombre,
        tpTipo: data.tetiqueta.tpTipo,
      },
    });
  }

  getPrintRule() {
    let id = this.activatedRoute.snapshot.params.id;
    this.printsRulesService.getPrintRule(id).subscribe(
      (data) => {
        this.setValues(data);
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  goList() {
    this.router.navigate([this.routing.list]);
  }

  getlistValuesEtiqueta() {
    this.listValueService.listValuesEtiqueta().subscribe(
      (data) => {
        this.listValuesEtiqueta = data;
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getlistValuesFabricantes() {
    this.listValueService.listValuesFabricantes().subscribe(
      (data) => {
        this.listValuesFabricantes = data;
        this.getlistValuesMarcas();
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getlistValuesFormatosImpresion() {
    this.listValueService.listValuesFormatosImpresion().subscribe(
      (data) => {
        data.sort(this.sortFormatosImpresion);
        this.listValuesFormatosImpresion = data;
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  getlistValuesMarcas() {
    this.listValueService.listValuesMarcas().subscribe(
      (data) => {
        this.listValuesMarcas = data;
        if (
          this.operation === "edicion" &&
          this.activatedRoute.snapshot.params.id
        ) {
          this.getPrintRule();
        }
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  setValueTypeTag(value) {
    this.printsRules.patchValue({
      tetiqueta: {
        tpNombre: value?.item?.tpNombre,
        tpTipo: value?.item?.tpTipo,
      },
    });
  }

  setValueBrand(value) {
    this.printsRules.patchValue({
      riMarca: value.item,
    });
  }

  setValuePrintsFormats(value) {
    this.printsRules.patchValue({
      formatosimpresion: {
        fiDesc: value?.item?.fiDesc,
        fiId: value?.item?.fiId,
      },
    });
  }

  setValueValorPlaca(value) {
    this.printsRules.patchValue({
      riTipoEtiqueta: value.item,
    });
  }

  valueSelector(value) {
    switch (value.id) {
      case "tpTipo":
        this.setValueTypeTag(value);
        break;
      case "maId":
        this.setValueBrand(value);
        break;
      case "fiId":
        this.setValuePrintsFormats(value);
        break;
      case "ValorPlaca":
        this.setValueValorPlaca(value);
        break;
    }
  }

  formatToSave() {
    this.printsRules.patchValue({
      riMarca: this.printsRules.value.riMarca["maId"],
      riTipoEtiqueta: this.printsRules.value.riTipoEtiqueta["ValorPlaca"],
    });
  }

  onUpdate() {
    this.printsRulesService
      .updatePrintRule(this.printsRules.value, this.printsRules.value.riIndice)
      .subscribe(
        (data) => {
          this.toastrAlertService.toastrSuccess(
            data.mensaje,
            this.routing.list
          );
        },
        (err) => {
          this.toastrAlertService.toastrFail(err.error.mensaje);
        }
      );
  }

  onCreate() {
    this.printsRulesService.createPrintRule(this.printsRules.value).subscribe(
      (data) => {
        this.toastrAlertService.toastrSuccess(data.mensaje, this.routing.list);
      },
      (err) => {
        this.toastrAlertService.toastrFail(err.error.mensaje);
      }
    );
  }

  validateForm(): boolean {
    let stateTEtiqueta = this.validateLists(
      this.listValuesEtiqueta,
      "tpTipo",
      this.printsRules.value.tetiqueta
    );
    let stateTipoEtiqueta = this.validateLists(
      this.listValuesFabricantes,
      "ValorPlaca",
      this.printsRules.value.riTipoEtiqueta
    );
    let stateMarca = this.validateLists(
      this.listValuesMarcas,
      "maId",
      this.printsRules.value.riMarca
    );
    let stateFormatosImpresion = this.validateLists(
      this.listValuesFormatosImpresion,
      "fiId",
      this.printsRules.value.formatosimpresion
    );
    let text: string = "";
    text = stateTEtiqueta ? "" : text + "El tipo de etiqueta es incorrecto. ";
    text = stateTipoEtiqueta ? "" : text + "El tipo de placa es incorrecto. ";
    text = stateMarca ? "" : text + "La marca es incorrecta. ";
    text = stateFormatosImpresion ? ""
      : text + "El formato de impresión es incorrecto. ";
    if (text != "") {
      text = text.substring(0, text.length - 1);
      this.toastrAlertService.toastrFail(text);
    }
    return (
      stateTEtiqueta &&
      stateTipoEtiqueta &&
      stateMarca &&
      stateFormatosImpresion
    );
  }

  onSave() {
    let invalidFields = this.commonService.findInvalidControls(
      this.printsRules.controls
    );
    if (invalidFields.length > 0) {
      let text = this.commonService.getValueOfLabelsById(invalidFields);
      this.toastrAlertService.toastrFail(text);
    } else {
      if (this.validateForm()) {
        this.formatToSave();
        if (this.operation === "edicion") {
          this.onUpdate();
        } else if (this.operation === "creacion") {
          this.onCreate();
        }
      }
    }
  }

  validateLists(listValues: any[], id: string, valueToFind: any): boolean {
    let object = listValues.find((item) => item[id] === valueToFind[id]);
    return object ? true : false;
  }

  sortFormatosImpresion(a, b) {
    let reA = /[^a-zA-Z]/g;
    let reN = /[^0-9]/g;

    let aA = a.fiId.replace(reA, "");
    let bA = b.fiId.replace(reA, "");

    if (aA === bA) {
      let aN = parseInt(a.fiId.replace(reN, ""));
      let bN = parseInt(b.fiId.replace(reN, ""));

      return aN === bN ? 0 : aN > bN ? 1 : -1;
    } else {
      return aA > bA ? 1 : -1;
    }
  }
}
